export default {
  education: {
    webinar: {
      title: "Inscrivez-vous à l'événement pour accéder à l'enregistrement",
      text: "Vous pouvez vous connecter automatiquement avec les données de votre compte actuel ou saisir les données manuellement à l'étape suivante.",
      label: "En vous inscrivant, vous acceptez",
      link: "conditions de transfert au partenaire de service MTS Link",
      close: "Saisir les données manuellement",
      submit: "S'inscrire",
    },
    metaTitle: "Éducation",
    noContentLang: "Il n'y a pas encore de documents publiés dans cette langue",
    titles: {
      material: "Formation pour les médecins",
      course: "Cours de formation pour médecins",
      simulator: "Simulateurs pour médecins",
      webinar: "Webinaires pour les médecins",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Type de matériaux",
        },
        lang: {
          placeholder: "Langue",
        },
        status: {
          placeholder: "Statut",
          values: {
            actual: "En cours",
            overpast: "Passé",
          },
        },
        specialty: {
          placeholder: "Spécialité",
        },
      },
      tabs: {
        material: "Tous les matériaux",
        course: "Cours",
        simulator: "Simulateurs",
        webinar: "Webinaires",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Vos matériaux",
          course: "Vos cours",
          simulator: "Vos simulateurs",
          webinar: "Vos webinaires",
        },
        recomended: {
          material: "Matériaux recommandés",
          course: "Cours recommandés",
          simulator: "Simulateurs recommandés",
          webinar: "Webinaires recommandés",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Leçon",
      Files: "Fichiers",
      DownloadAll: "Tout télécharger",
    },
    status: {
      success: "Complété",
      unsuccess: "Non terminé",
      stop: "Indisponible",
    },
  },
  Tests: {
    table: {
      tests: "Tests",
      description: "Description",
      points: "Points",
      status: "Statut",
    },
    modal: {
      title: "Voulez-vous terminer le test ?",
    },
    questions: {
      question: "Question",
      answer: "Répondre",
      correct: "Correct",
      incorrect: "Incorrect",
      moderated: "En cours d'examen",
      navigation: "Tester la navigation",
      enterAnswer: "Entrez la réponse...",
    },
    errors: {
      required: "Question obligatoire",
    },
    submit: "Terminer les tests",
    result: "Résultat",
    repeat: "Reprendre",
  },
  afterPayCourse: {
    title: "Avez-vous acheté le cours avec succès",
    text: "Vous avez maintenant accès au matériel de formation",
    buttonText: "Aller au cours",
  },
  coursePage: {
    courseType: {
      course: "Taux",
      simulator: "Simulateur",
      webinar: "Webinaire",
    },
    groupNumber: "{n} - ème flux",
    manager: "Gestionnaire",
    curator: "Curateur",
    free: "Gratuitement",
  },
  coursesPage: {
    materials: "Matériau",
    schools: "Écoles d'auteurs",
    universities: "établissement d'enseignement supérieur",
    showPast: "Afficher le passé",
    emptyList: "Il n'y a pas de tels matériaux",
    show: "Montrer",
    result1: "résultat",
    result2: "résultat",
    result5: "résultat",
    filters: "Filtres",
    clear: "Nettoyer",
  },
};
